// extracted by mini-css-extract-plugin
module.exports = {"btnStyle":"nameColumnRenderer_btnStyle__3kNXa","linkText":"nameColumnRenderer_linkText__2CloH","inlineError":"nameColumnRenderer_inlineError__DY6K6"};